
import * as api from "../../../api"; 


  
export const getCoursesByAppToken = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getCoursesByAppToken(post);
         console.log(data)
       
        
        return data
     } catch (error) {
         
    }
}

export const getAllProductsByApp = (post) => async (dispatch)=>{
    try {
        const {data } = await api.getAllProductsByApp(post);
         console.log(data)
       
        
        return data
     } catch (error) {
         
    }
}





